//add the textContent of link here
const linksContent = ['secure site']

function addAriaLabelOpensInNewTab() {
  const el = document.getElementsByTagName('a')
  el?.forEach(item => {
    if (linksContent?.includes(item?.textContent)) {
      item?.setAttribute('aria-label', item?.textContent + ' Opens in new tab')
    }
  })
}
document.addEventListener('DOMContentLoaded', addAriaLabelOpensInNewTab)
